// extracted by mini-css-extract-plugin
export default {"post-btn":"PostButton_post-btn__KJRPF"};